import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FirstServiceFeeWaived({
  isFirstOrder
}: {
  isFirstOrder: boolean;
}) {
  const { t } = useTranslation();
  if (!isFirstOrder) {
    return null;
  }
  return (
    <div className="w-full flex justify-end">
      <div className="bg-[#F79009] rounded-full px-[10px] h-[20px] flex items-center justify-center">
        <div className="justify-start text-white text-xs font-bold font-['Poppins']">
          {t('price_details.first_service_fee_waived', {
            defaultValue: 'Service fee waived (first order)'
          })}
        </div>
      </div>
    </div>
  );
}
